"use client";
import React, { useState } from "react";

export default function FeaturesTabs({ data }) {
  const {
    title,
    subtitle,
    features = [],
    align = "center",
    background = {},
    extra = {},
  } = data || {};

  const [active, setActive] = useState(0);

  const bgStyle =
    background.type === "gradient"
      ? { backgroundImage: background.value }
      : background.type === "color"
        ? { backgroundColor: background.value }
        : background.type === "image"
          ? {
              backgroundImage: `url(${background.value})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }
          : {};

  const alignClass =
    align === "center"
      ? "text-center"
      : align === "right"
        ? "text-right"
        : "text-left";

  return (
    <section className="py-20 px-4" style={bgStyle}>
      <div className="max-w-5xl mx-auto">
        {title && (
          <h2 className={`text-3xl font-bold ${alignClass}`}>{title}</h2>
        )}
        {subtitle && (
          <p className={`text-muted mt-2 ${alignClass}`}>{subtitle}</p>
        )}

        <div className="mt-10">
          <div className="flex flex-wrap gap-4 justify-center border-b pb-4">
            {features.map((f, i) => (
              <button
                key={i}
                onClick={() => setActive(i)}
                className={`px-4 py-2 font-medium border-b-2 ${
                  i === active
                    ? "text-primary border-primary"
                    : "text-muted-foreground border-transparent"
                }`}
              >
                {f.title}
              </button>
            ))}
          </div>

          <div className="mt-8 text-muted-foreground text-center max-w-2xl mx-auto">
            <p>{features[active]?.description}</p>
            {features[active]?.link?.href && (
              <a
                href={features[active].link.href}
                className="text-primary underline block mt-2 text-sm"
              >
                {features[active].link.text || "Learn more"}
              </a>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
